import React, { ImgHTMLAttributes, useEffect, useState } from 'react';
import Cloudinary from 'utils/Cloudinary';

type ImageComponentProps = {
  src?: string;
  animate?: boolean;
  alt?: any;
  handleOnLoad?: () => void;
  className?: string;
  width?: number;
  height?: number;
  options?: Record<string, unknown>;
  cloudinaryTransform?: boolean;
} & ImgHTMLAttributes<HTMLImageElement>;

function transformImage(url, options, cloudinaryTransform) {
  if (!cloudinaryTransform) {
    return url;
  }

  try {
    if (url && url.indexOf('cloudinary') > -1) {
      return Cloudinary.createCloudinaryUrl(url, options);
    }
    return url;
  } catch (e) {
    console.error(e);
    return url;
  }
}

function ImageComponent({
  src,
  alt = '',
  options,
  animate,
  style = {},
  cloudinaryTransform = true,
  handleOnLoad = () => {},
  ...others
}: ImageComponentProps) {
  const [ready, setReady] = useState(false);

  const animateStyle: any = {};

  if (animate) {
    animateStyle.opacity = ready ? 1 : 0;
    animateStyle.transition = 'opacity .3s';
  }

  const imgStyle = Object.assign({}, style, animateStyle);
  const imgSrc = transformImage(src, options, cloudinaryTransform);

  useEffect(() => {
    const image = new Image();

    const onImageLoad = () => {
      setReady(true);
      handleOnLoad();
    };

    image.addEventListener('load', onImageLoad);

    image.src = imgSrc;

    return () => {
      image.removeEventListener('load', onImageLoad);
    };
  }, [imgSrc, handleOnLoad]);

  return <img alt={alt} style={imgStyle} src={imgSrc} {...others} />;
}

export default ImageComponent;
